/*
 * *
 *   ~  * Copyright (c) by INFODATA-GROUP. All rights reserved.
 *   ~  * No part of this publication may be reproduced, distributed,
 *   ~  * or transmitted in any form or by any means, including photocopying, recording,
 *   ~  * or other electronic or mechanical methods, without the prior written permission of the publisher,
 *   ~  * except in the case of brief quotations embodied in critical
 *   ~  * reviews and certain other noncommercial uses permitted by copyright law.
 *   ~  * AUTHOR : bs
 *   ~  * DATE : 29/04/2025 17:03
 *
 */

import { Component, inject, OnInit } from '@angular/core';

import { InitService, LoaderService } from '@infodata-group/inf-commons';
import { RouterOutlet } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { DeviceDetectorService } from 'ngx-device-detector';
import {
  FullPageLoaderComponent as LoaderDesktop,
  NotificationsContainerComponent as NotificationDesktop,
  RestErrorComponent,
} from '@infodata-group/inf-commons-desktop';
import {
  FullPageLoaderComponent as LoaderMobile,
  NotificationsContainerComponent as NotificationMobile,
} from '@infodata-group/inf-commons-mobile';

/**
 * @deprecated
 * Use InfAppComponent from @infodata-group/inf-commons-desktop instead.
 */
@Component({
  selector: 'infl-app',
  imports: [
    TranslateModule,
    RouterOutlet,
    RestErrorComponent,
    LoaderDesktop,
    LoaderMobile,
    NotificationDesktop,
    NotificationMobile
],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
  standalone: true,
})
export class AppComponent implements OnInit {
  private loader = inject(LoaderService);
  private initService = inject(InitService);
  protected device = inject(DeviceDetectorService);

  public isIE = false;
  public isLoading: boolean;
  public canDisplay = false;
  public showLoader = false;

  constructor() {
    this.isLoading = true;
    this.checkIE();
    this.loader.subscribe((showLoader) => {
      this.showLoader = showLoader;
    });
  }

  ngOnInit() {
    this.isLoading = !this.initService.isLoaded;
    this.initService.subscribe((event) => {
      if (event.name === 'config' && event.value) {
        this.isLoading = false;
      }
      if (event.name === 'maintenance') {
        this.isLoading = false;
      }
    });
  }

  private checkIE() {
    this.isIE =
      navigator.appName === 'Microsoft Internet Explorer' ||
      /Edge\/\d./i.test(navigator.userAgent) ||
      /Trident\/\d./i.test(navigator.userAgent);
  }
}
